<script lang="ts" setup>
import { Toaster as Sonner, type ToasterProps } from 'vue-sonner'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {faCheckCircle, faExclamationTriangle, faInfoCircle, faSpinnerThird, faXmarkCircle} from "@fortawesome/pro-solid-svg-icons";

const props = defineProps<ToasterProps>()
</script>

<template>
  <Sonner
    class="toaster group"
    v-bind="props"
    :toast-options="{
      classes: {
        toast: 'group toast group-[.toaster]:bg-white group-[.toaster]:text-slate-950 group-[.toaster]:border-slate-200 group-[.toaster]:shadow-lg dark:group-[.toaster]:bg-slate-950 dark:group-[.toaster]:text-slate-50 dark:group-[.toaster]:border-slate-800',
        description: 'group-[.toast]:text-slate-500 dark:group-[.toast]:text-slate-400',
        actionButton:
          'group-[.toast]:!bg-white group-[.toast]:!text-slate-950 group-[.toast]:!border-solid group-[.toast]:!border-2 group-[.toast]:!border-black',
        cancelButton:
          'group-[.toast]:bg-slate-100 group-[.toast]:text-slate-500 dark:group-[.toast]:bg-slate-800 dark:group-[.toast]:text-slate-400',
      },
    }"
  >
    <template #loading-icon>
      <FontAwesomeIcon :icon="faSpinnerThird" spin size="xl" class="text-green-500" data-tests="toast-loading"/>
    </template>
    <template #success-icon>
      <FontAwesomeIcon :icon="faCheckCircle" size="xl" class="text-green-500" data-tests="toast-success" />
    </template>
    <template #error-icon>
      <FontAwesomeIcon :icon="faXmarkCircle" size="xl" class="text-red-500"  data-tests="toast-error" />
    </template>
    <template #info-icon>
      <FontAwesomeIcon :icon="faInfoCircle" size="xl" class="text-blue-500" data-tests="toast-info" />
    </template>
    <template #warning-icon>
      <FontAwesomeIcon :icon="faExclamationTriangle" size="xl" class="text-yellow-500" data-tests="toast-warning" />
    </template>
  </Sonner>
</template>


<style>
[data-sonner-toast] [data-content] {
  width: 100%;
  margin-right: 5px;
}
[data-sonner-toast] [data-description] {
  margin-right: 25px;
}
[data-sonner-toast] [data-icon] {
    align-self: start;
}
</style>
